import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CurrentRoute } from '@knalgeel/pandora';

export interface SubHeaderItem {
    name: string,
    href?: string
}

@Component({
    selector: 'app-sub-header',
    templateUrl: './sub-header.component.html',
    styleUrls: ['./sub-header.component.scss'],
    imports: [RouterLink, RouterLinkActive],
})
export class SubHeaderComponent implements OnInit, OnChanges {

    @Input() items: SubHeaderItem[] = [];

    constructor(private route: CurrentRoute) {
    }

    ngOnInit() {
        this.updateLinks();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['items']) {
            this.updateLinks();
        }
    }

    updateLinks() {
        this.items = this.items.map(item => ({
            ...item,
            href: item.href ? this.replaceArguments(item.href, this.route.snapshot.params) : item.href,
        }));
    }

    replaceArguments(href: string, params: Record<string, string>): string {
        return Object.keys(params).reduce((acc, key) => acc.replace(`:${key}`, params[key]), href);
    }

    isActivated(item: SubHeaderItem): boolean {
        return `/${item.href}` === decodeURIComponent(window.location.pathname);
    }

}
